// extracted by mini-css-extract-plugin
export default {"wrapper":"TermsAndCondition_wrapper__iV4hN"};